import { useState } from "react";
import { DemoSection } from "system/demo";
import { REPLACE_ZDF_Toggle } from "open-modules/zdf/component/form-2";
import { View } from "react-native-web";
import { Banner } from "component/banner";
import { colorSurfaceInfo, colorTextPrimaryOnLightColorBg } from "component/color";
import { Pad } from "component/basics";
import { RichText } from "component/richtext";

export function ZDFToggleDemo() {
    const [switchValue, setSwitchValue] = useState(false);

    return (
        <View>
            <Banner color={colorSurfaceInfo}>
                <RichText text="This component extends the core **Toggle** with a **disabled** state and a compact **size** option." color={colorTextPrimaryOnLightColorBg}/>
            </Banner>
            <Pad size={32}/>
            <DemoSection text="Toggle Size Regular">
                <REPLACE_ZDF_Toggle text='Toggle' value={switchValue} onChange={setSwitchValue} />
                <REPLACE_ZDF_Toggle emoji='😭' text='Toggle with emoji' value={switchValue} onChange={setSwitchValue} />
                <REPLACE_ZDF_Toggle emoji='😭' text='Spread Toggle' spread value={switchValue} onChange={setSwitchValue} />
                <REPLACE_ZDF_Toggle text='This is a toggle with a very long label that needs to be wrapped onto another screen in order to not look bad' value={switchValue} onChange={setSwitchValue} />
                <REPLACE_ZDF_Toggle text="Disabled toggle" value={switchValue} onChange={setSwitchValue} disabled />
            </DemoSection>
            <DemoSection text="Toggle Size Compact">
                <REPLACE_ZDF_Toggle text="Toggle" value={switchValue} onChange={setSwitchValue} size="compact" />
                <REPLACE_ZDF_Toggle emoji="😭" text="Toggle with emoji" value={switchValue} onChange={setSwitchValue} size="compact" />
                <REPLACE_ZDF_Toggle emoji="😭" text="Spread Toggle" spread value={switchValue} onChange={setSwitchValue} size="compact" />
                <REPLACE_ZDF_Toggle text="This is a toggle with a very long label that needs to be wrapped onto another screen in order to not look bad" value={switchValue} onChange={setSwitchValue} size="compact" />
                <REPLACE_ZDF_Toggle text="Disabled toggle" value={switchValue} onChange={setSwitchValue} disabled size="compact" />
            </DemoSection>
        </View>
    );
}